import "styles/customer.css";
import { UsergroupAddOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { Header } from "components/Common";
import {
  AddCustomerModal,
  CustomersTable,
} from "components/Customer/AllCustomer";
import React, { useState } from "react";
import { deleteCustomer } from "store/features/customer/customer.service";
import { useAppDispatch } from "store/store";
import { CustomerI } from "types";
import { GTagEventCategory, GTagEventType, sendGTagEvent } from "utils/gtag";

const AllCustomers: React.FC = () => {
  const dispatch = useAppDispatch();
  const [modalType, setModalType] = useState<"add" | "edit">("edit");
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [defaultValues, setDefaultValues] = useState<CustomerI | null>(null);

  return (
    <div className="page-padding">
      <Header heading="All Customers">
        <Button
          type="primary"
          size="large"
          icon={<UsergroupAddOutlined />}
          onClick={() => {
            setDefaultValues(null);
            setModalType("add");
            setShowAddModal(true);
          }}
        >
          Add Customer
        </Button>
      </Header>
      <CustomersTable
        onActionPress={(type, data) => {
          setDefaultValues(data);

          if (type.key === "edit") {
            setModalType("edit");
            setShowAddModal(true);
          }

          if (type.key === "delete") {
            dispatch(deleteCustomer({ id: data.id }));
            message.success("Customer has been deleted successfully!");

            // sending gTag event here...
            sendGTagEvent(
              GTagEventType.DELETE_CUSTOMER,
              GTagEventCategory.CUSTOMERS
            );
          }
        }}
      />

      <AddCustomerModal
        type={modalType}
        open={showAddModal}
        onCancel={() => {
          setDefaultValues(null);
          setShowAddModal(false);
        }}
        defaultValues={defaultValues}
      />
    </div>
  );
};

export default AllCustomers;
